import React from "react";
import { Icon } from "antd";
import styles from "./singleSelectHeader.scss";

const SingleSelectHeader = ({ title, onCancel, allowClear, handleClear, value }) => (
  <div className={styles.header}>
    <span className={styles.title}>
      {title || "Kategorija"}
    </span>
    <div>

    {allowClear && value && (
      <span className={styles.clearButton} onClick={handleClear}>Poništi</span>
    )}
    <Icon type="close" onClick={onCancel} className={styles.closeButton} />
    </div>
  </div>
);

SingleSelectHeader.defaultProps = {
  title: ""
};

export default SingleSelectHeader;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleSelectModal/SingleSelectHeader/index.tsx